import ErrorNLoadging from './ErrorNLoading';

const store = {
  ...ErrorNLoadging
};

export default store;